import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { StringParam, useQueryParams } from 'use-query-params';

import * as routes from '@routes';
import { BasePreloader } from '@components';
import { useAuthStore, usePageStore, userRoleChecks } from '@stores';
import { useAuctioneersApi } from '@api/auctioneers';
import { User } from '@types';

const OAuthCSAS: React.FC = () => {
  const pageState = usePageStore();
  const auctioneersApi = useAuctioneersApi();
  const navigate = useNavigate();
  const authState = useAuthStore();
  const { isOfRoleSuperAdmin } = userRoleChecks(authState.user as User);
  const defaultQuery = React.useMemo(
    () => ({
      code: StringParam,
      state: StringParam,
      error: StringParam,
    }),
    []
  );
  const [query] = useQueryParams(defaultQuery);

  useEffect(() => {
    if (!!query.error) {
      toast.error(query.error);
    }

    if (authState.isLogged && !!query.code && !!query.state) {
      process();
    } else {
      navigate('/');
    }
    return () => auctioneersApi.cancelAllRequests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const process = async () => {
    try {
      const res = await auctioneersApi.getCSASToken(query.code || '', query.state || '');

      navigate(
        `${pageState.getPagePath(
          !isOfRoleSuperAdmin() ? routes.admin.MY_COMPANY_UPDATE : routes.admin.AUCTIONEER_UPDATE,
          {
            ':id': res.data.data.auctioneerId,
          }
        )}?step=7&csas=true`
      );
    } catch (err) {
      if (auctioneersApi.isCancel(err)) {
        return;
      }
      navigate('/');
    }
  };

  return (
    <div className="d-flex vw-100 vh-100 align-items-center justify-content-center">
      <BasePreloader size={50} />
    </div>
  );
};

export default OAuthCSAS;
